import companionImage from "../assets/images/cycloptCompanion.png";
import companionLiteImage from "../assets/images/companionLite.png";
import companionUnlimitedImage from "../assets/images/companionUnlimited.png";
import { Box, Typography, Divider, Grid } from "@mui/material";
import { memo } from "react";
import theme from "../theme";
import CheckIcon from "@mui/icons-material/Check";
import { OfferBox, OfferVariantBox } from "../screens/ChoosePlan.jsx";
import { ThirdCheckbox, ThirdBackgroundButton, PrimaryBorderButton } from "#components";


export const ServiceCheckBox = ({ title, titleSx, price, selected, setSelected }) => (
	<Box display="flex" alignItems="center">
		<ThirdCheckbox  size="1.5rem" checked={selected} onChange={() => setSelected(!selected)}/>
		<Typography sx={{ ...titleSx }}>
			{title}
		</Typography>
		<Typography sx={{ marginLeft: "0.2rem", fontSize: "small", fontWeight: "bold" }}>
			{`+€${price}`}
		</Typography>
		<Typography sx={{ color: theme.palette.red.main, marginLeft: "0.2rem" }}>*</Typography>
	</Box>
);


export const FreeCheckBox = ({ title, titleSx, selected, setSelected }) => (
	<Box display="flex" alignItems="center">
		<ThirdCheckbox size="1.5rem" checked={selected} onChange={() => setSelected(!selected)}/>
		<Typography sx={{ ...titleSx }}>
			{title}
		</Typography>
	</Box>
);

const PricingBox = ({ price }) => (
	<>
		<Box display="flex" alignItems="baseline">
			<Typography variant="h5" sx={{ color: "#000", fontWeight: 700 }}>{`€ ${price}`}</Typography>
			<Typography variant="body2" sx={{ color: theme.palette.grey.silver, marginLeft: "0.2rem" }}>{"per month"}</Typography>
		</Box>
		<Divider sx={{ marginTop: "0.5rem", marginBottom: "0.5rem" }}></Divider>
	</>
);

const CompanionComponent = ({ freeSelected, setFreeSelected, solo, isLite, isUnlimited, navigate }) => (
	<Box>
		<Box
			component="img"
			src={isLite ? companionLiteImage : isUnlimited ? companionUnlimitedImage : companionImage}
			alt="Companion"
			sx={{ height: "5rem", objectFit: "contain" }}
		/>
		{isLite && (
			<PricingBox price="0" />
		)}
		{isUnlimited && (
			<PricingBox price="20" />
		)}
		<Box>
			{(isLite || isUnlimited) && (
				<OfferBox title={`${isLite ? "30" : "Unlimited"} commits / month`} CirleOutlineComponent={CheckIcon} cirleOutlineColor={theme.palette.pink.main} titleSx={{ fontWeight: "bold" }} circleMarginLeft="0.5rem"/>
			)}
			<OfferVariantBox title="Source Code Analysis" subtitle="Maintainability + Security + Performance" CirleOutlineComponent={CheckIcon} circleMarginLeft="0.5rem"/>
			<OfferBox title="Quality Gates" CirleOutlineComponent={CheckIcon} cirleOutlineColor={theme.palette.pink.main} titleSx={{ fontWeight: "bold" }} circleMarginLeft="0.5rem"/>
			<OfferBox title="Cyclopt Notifications" CirleOutlineComponent={CheckIcon} cirleOutlineColor={theme.palette.pink.main} titleSx={{ fontWeight: "bold" }} circleMarginLeft="0.5rem"/>
			<OfferBox title="Cyclopt Profile" CirleOutlineComponent={CheckIcon} cirleOutlineColor={theme.palette.pink.main} titleSx={{ fontWeight: "bold" }} circleMarginLeft="0.5rem"/>
			<OfferBox title="Cyclopt API" CirleOutlineComponent={CheckIcon} cirleOutlineColor={theme.palette.pink.main} titleSx={{ fontWeight: "bold" }} circleMarginLeft="0.5rem"/>
			<OfferBox title="Cyclopt Plugins" CirleOutlineComponent={CheckIcon} cirleOutlineColor={theme.palette.pink.main} titleSx={{ fontWeight: "bold" }} circleMarginLeft="0.5rem"/>
			<OfferBox title="Cyclopt MCP Server" CirleOutlineComponent={CheckIcon} cirleOutlineColor={theme.palette.pink.main} titleSx={{ fontWeight: "bold" }} circleMarginLeft="0.5rem"/>
			<OfferBox title="Automated Code Fixing" CirleOutlineComponent={CheckIcon} cirleOutlineColor={theme.palette.pink.main} titleSx={{ fontWeight: "bold" }} circleMarginLeft="0.5rem"/>
		</Box>
		{!isLite && !isUnlimited && (
			<>
				{solo && (
					<Divider sx={{ marginTop: "0.5rem", marginBottom: "0.5rem" }}></Divider>
				)}
				{solo && (
					<Box>
						<FreeCheckBox title="For 30 commits per month" titleSx={{ fontWeight: "bold" }} selected={freeSelected} setSelected={setFreeSelected}/>
					</Box>
				)}
				
			</>
		)}
		{isLite && (
			<Grid item pl="1rem" pt="1rem" pb="1rem">
				<PrimaryBorderButton
					id="configure-teams-plan-button"
					width="200px"
					title="Go LITE"
					onClick={() => window.location.assign("https://companion.cyclopt.com")}
				/>
			</Grid>
		)}
		{isUnlimited && (
			<Grid item pl="1rem" pt="1rem" pb="1rem">
				<ThirdBackgroundButton
					id="configure-teams-plan-button"
					width="200px"
					title="Go UNLIMITED"
					onClick={() => navigate("../checkout?companion=1")}
					// onClick={() => window.location.assign("https://cyclopt.com/lets-start/?companion=1")}
				/>
			</Grid>
		)}
	</Box>
);

export default memo(CompanionComponent);
